import * as React from 'react';
import { OrderShipmentStatus } from '../../../../models/ordering/enums/order-shipment-status';
import { SearchOrderSummary } from '../../../../models/ordering/search-order-summary';
import { formatCurrency } from '../../../../utils/currency-formatter';

interface IProps {
    onOrderClick: any;
    order: SearchOrderSummary;
}

export const FedexOrderRow = (props: IProps) => (
    <tr className={props.order.shipmentStatus === OrderShipmentStatus.Pending ? 'disabled' : ''}
        onClick={() => props.onOrderClick(props.order)}    >
        <td>{ props.order.id }</td>
        <td>{ props.order.dealerName }</td>
        <td>{ props.order.quantity }</td>
        <td>{ props.order.description }</td>
        <td>{ props.order.jobName }</td>
        <td>{ formatCurrency(props.order.amount) }</td>
    </tr>
);
